import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkNullAndReturnValue'
})
export class CheckNullAndReturnValuePipe implements PipeTransform {

  transform(value: any, arg: any): any {
    if (value != null) {
      return value[arg] === "." ? ".(Root)" : "." + value[arg];
    }
  }

}
